import React from "react";
import styled from "styled-components";
import BaseComponent from "./BaseComponent";
import ImgSrc from "../assets/hospitable-viking-blue.png";
import { Redirect } from "react-router-dom";


const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const TextDiv = styled.h1`
  font-size: 24px;
  color: #1cbff2;
`;

const StyledImg = styled.img`
  margin: 70px auto 0 auto;
  width: 300;
  height: 300;
`;

const CenteredButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

class Home extends BaseComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
            }}
          />
        ) : null}

        <StyledImg className="ui image" alt="Hospitable Viking" src={ImgSrc}></StyledImg>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </>
    );
  }
}

export default Home;
